import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useTable = () => useContext(Ctx);

export const TableProvider = ({ children }) => {
  const [me, setMe] = useState(null);
  const [booting, setBooting] = useState(true);
  const [years, setYears] = useState([]);
  const [yearId, setYearId] = useState(null);
  const [members, setMembers] = useState([]);
  const [settings, setSettings] = useState(null);
  const [data, setData] = useState({
    meetings: [], goals: [], commitments: [], feed: [], resources: [],
    parking: [], fines: [], baseline: [], highlights: [],
  });

  const loadIdentity = useCallback(async () => {
    if (!localStorage.getItem("table_token")) {
      setBooting(false);
      return;
    }
    try {
      const [meR, yR, mR, sR] = await Promise.all([
        api.get("/auth/me"), api.get("/years"), api.get("/members"), api.get("/settings"),
      ]);
      setMe(meR.data);
      setYears(yR.data);
      setMembers(mR.data);
      setSettings(sR.data);
      setYearId((prev) => prev || meR.data.activeYearId || yR.data[0]?.id);
    } catch (e) {
      setMe(null);
    }
    setBooting(false);
  }, []);

  const refreshYearData = useCallback(async (yid) => {
    if (!yid) return;
    const q = { params: { yearId: yid } };
    const [meetings, goals, commitments, feed, resources, parking, fines, baseline, highlights] =
      await Promise.all([
        api.get("/meetings", q), api.get("/goals", q), api.get("/commitments", q),
        api.get("/feed", q), api.get("/resources", q), api.get("/parking", q),
        api.get("/fines", q), api.get("/baseline", q), api.get("/highlights", q),
      ]);
    setData({
      meetings: meetings.data, goals: goals.data, commitments: commitments.data,
      feed: feed.data, resources: resources.data, parking: parking.data,
      fines: fines.data, baseline: baseline.data, highlights: highlights.data,
    });
  }, []);

  useEffect(() => { loadIdentity(); }, [loadIdentity]);
  useEffect(() => { if (me && yearId) refreshYearData(yearId); }, [me, yearId, refreshYearData]);

  const year = years.find((y) => y.id === yearId) || null;
  const activeYear = years.find((y) => y.status === "Active") || null;
  const isArchive = !!year && year.status !== "Active";
  const canWrite = !!me && me.status !== "Alumni" && !isArchive;

  const refreshMembers = async () => setMembers((await api.get("/members")).data);
  const refreshYears = async () => setYears((await api.get("/years")).data);

  const signOut = () => {
    localStorage.removeItem("table_token");
    window.location.href = "/";
  };

  const memberById = (id) => members.find((m) => m.id === id) || null;
  const activeMembers = members.filter((m) => m.status === "Active");

  return (
    <Ctx.Provider
      value={{
        me, booting, years, year, yearId, setYearId, activeYear, isArchive, canWrite,
        members, activeMembers, memberById, settings, setSettings, ...data,
        refresh: () => refreshYearData(yearId), refreshMembers, refreshYears,
        loadIdentity, signOut,
      }}
    >
      {children}
    </Ctx.Provider>
  );
};
